/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:43:46
 */
import en from 'element-ui/lib/locale/lang/en'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Interpretarea raportului AI",
        train: "Plan de antrenament",
        loading: "Se încarcă, vă rugăm așteptați...",
        loadingError1: "Încărcarea raportului a eșuat",
        loadingError2: "Ne cerem scuze pentru neplăceri. Vă rugăm să încercați din nou mai târziu.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Înregistrare/Autentificare',
        registerAndLogin: 'Conectare/Înregistrare',
        userLogin: 'Conectare',
        title: 'Conturile de telefon și e-mail sunt independente. Vă rugăm să verificați tipul de cont.',
        mobileLogin: 'Telefon',
        emailLogin: 'E-mail',
        email: 'E-mail',
        loginBtn: 'Conectare',
        autoLogin: 'Ține-mă conectat',
        retransmission: 'Retrimitere în {item} secunde',
        formList: [
            {
                label: 'Număr de telefon',
                placeholder: 'Obține Cod',
            },
            {
                label: 'Cod de verificare',
                placeholder: 'Cod de verificare',
            },
            {
                label: 'Adresă de e-mail',
            },
        ],
        btn: {
            submit: 'Creați un cont nou',
            title: 'Informațiile corecte sunt foarte importante. Vă rugăm să completați cu atenție.',
        },
        rule: {
            phone: {
                requiredMsg: 'Formatul numărului de telefon este invalid',
                patternMsg: 'Numărul de telefon nu este înregistrat. Vă rugăm să creați un cont nou.',
            },
            authCode: {
                requiredMsg: 'Cod de verificare incorect. Vă rugăm să încercați din nou.',
            },
            email: {
                requiredMsg: 'Formatul adresei de e-mail este invalid',
                patternMsg: 'Adresa de e-mail nu este înregistrată. Vă rugăm să creați un cont nou.',
            },
        },
        codeSuccess: 'Codul de verificare a fost trimis. Vă rugăm să verificați.',
        success: 'Trimis cu succes',
        error: 'Trimitere eșuată',
        loginSuccess: 'Conectare reușită',
        account: {
            accountTitle: 'Conectare',
            registerTitle: 'Înregistrare',
            resetTitle: 'Setare parolă',
            password: 'Parolă',
            placeholder: 'Vă rugăm să introduceți parola',
            codeLogin: 'Autentificare cu cod de verificare',
            accountLogin: 'Autentificare cu parolă',
            forgotPassword: 'Ați uitat parola?',
            registerTips:[
                'Nu aveți cont?', 
                'Înregistrare', 
                'Contul există deja',
                'Înregistrați-vă acum',
            ],
            checkRule: [
                '8-20 de caractere',
                'Cel puțin o literă mare',
                'Cel puțin o literă mică',
                'Cel puțin o cifră', 
                'Parolele nu corespund'
            ],
            errorTips: [
                'Parola este incorectă', 
                'Autentificare eșuată', 
                'Contul nu există'
            ],
            reset:[
                'Resetare parolă', 
                "Pasul următor",
                'Noua parolă nu poate fi identică cu parola anterioară', 
                'Omitere',
                'Parola a fost setată cu succes'
            ],
            setPasswordTips:'Parola trebuie să aibă între 8 și 20 de caractere și să includă litere mari, litere mici și cifre.',
            confirmPassword: "Confirmare parolă",
        },
        switchButton: 'Autentificare cu parolă',
        switchButton1: 'Autentificare cu cod de verificare',
        loginTips: 'Conturile neînregistrate vor fi înregistrate automat după o autentificare reușită.',
        otherLogin: 'Alte metode de autentificare',
        newEmailLogin: 'Autentificare cu e-mail',
        newPhoneLogin: 'Autentificare cu numărul de telefon',
        bindLineTips:'Sau',
        bindEmail: 'Autentificare cu e-mailul asociat',
        bindPhone: 'Autentificare cu numărul de telefon asociat',
        bindAndContinue: "Conectați și continuați",
        bind: "Conectați",
        bindEmailTitle: 'Conectați e-mailul',
        bindEmailTips1: "Nu s-au găsit info e-mail {item}",
        bindEmailTips2: "Conectați e-mailul pentru a continua",
        bindEmailTips3: "E-mail neconectat. Conectați-vă pentru autentificare și recuperare parolă.",
        boundTitle: 'V-ați înregistrat înainte?',
        boundCenterTitle1:'Dacă sunteți utilizator nou',
        boundCenterTips1:'Creați un cont pentru a începe',
        boundCenterTitle2:'Dacă aveți deja un cont',
        boundCenterTips2:'Conectați pentru a sincroniza datele',
        boundCenterTips3:'Vă rugăm să asociați un cont înregistrat',
        boundCenterTips4:'Recomandat',
        boundCenterTips5:'Conectați {item} la contul existent',
        boundCenterTips6:'Datele și rapoartele se vor sincroniza',
        boundButton1: 'Creați cont cu {item}',
        boundButton2: 'Conectați contul existent',
        phoneCode:"Login cu cod SMS",
        phonePassword:"Login cu tel. și parolă",
        emailCode:"Login cu cod e-mail",
        emailPassword:"Login cu e-mail și parolă",
        accountDoesNotExist:"Acest cont nu este încă înregistrat. Vă rugăm să finalizați înregistrarea folosind un cod de verificare prin e-mail sau prin {item}.",
        toRegister:"Înregistrează-te",
        bindNow: "Asociază acum",
        bindError:[
            'Asocierea a eșuat',
            'Dezasociere reușită',
            'Dezasociere eșuată',
            'Autorizare eșuată',
            'Autorizare eșuată, nu se pot prelua informațiile contului',
            'Asociere reușită',
            'Contul nu există. Vă rugăm să asociați un cont înregistrat.',
            'Asociere eșuată. Acest cont este deja asociat cu contul {item}. [{nickname}]',
            'Autorizat și înregistrat ca un cont. Dezasocierea nu este permisă.',
            'Contul nu există. Vă rugăm să folosiți codul de verificare pentru autentificare și înregistrare.',
        ],
        accountSecurity: {
            faceBook:'Cont Facebook',
            google: 'Cont Google',
            isBind: 'Neasociat',
            dialogTitle: 'Confirmați dezasocierea?',
            dialogCenter: 'După dezasocierea {item}, nu îl veți mai putea utiliza pentru a vă autentifica în acest cont.',
            bindFailure:'Asocierea a eșuat',
            bindFailureTips: 'Contul dvs. {item} este deja asociat cu contul de mai jos. Dacă doriți să îl asociați la contul curent, autentificați-vă mai întâi în contul de mai jos pentru a-l dezasocia.',
            returnButton:'Confirmare și revenire'
        },
        bindEmailError: [
            "E-mailul există deja."
        ],

    },
    // 注册页面
    register: {
        mobileRegister: 'Înregistrare cu numărul de telefon',
        emailRegister: 'Înregistrare cu e-mail',
        enroll: 'Numărul de telefon este deja înregistrat',
        enrollEmail: 'Această adresă de e-mail este deja înregistrată',
        search: 'Căutare',
        title: 'Conturile de telefon și e-mail sunt independente. Vă rugăm să verificați tipul de cont.',
        needRead: {
            agree: 'Am citit și sunt de acord cu',
            privacy: 'Politica de confidențialitate',
        },
        register: 'Înregistrare',
        check: 'Bifați "Politica de confidențialitate"',
        newUser: 'Înregistrare utilizator nou',
        form: {
            labelList: ['Nume', '* Sex', '* Înălțime', '* Vârstă'],
        },
        placeholder: ['Înregistrare utilizator nou', 'Vă rugăm să introduceți înălțimea', 'Vă rugăm să introduceți vârsta'],
        unit: ['Metric', 'Imperial', 'Ani'],
        sexOptions: {
            male: 'Masculin',
            female: 'Feminin',
        },
        btn: 'Trimite',
        rules: {
            metricheight: ['Intervalul de înălțime permis este 2ft 3in–6ft 7in. Vă rugăm să introduceți din nou.'],
            heightMsg: ['Intervalul de înălțime permis este 70–200 cm. Vă rugăm să introduceți din nou.'],
            ageMsg: ['Intervalul de vârstă permis este 10–99 ani. Vă rugăm să introduceți din nou.'],
            agePointMsg: ['Intrare invalidă: vârsta trebuie să fie un număr întreg. Vă rugăm să introduceți o vârstă validă.'],
        },
        success: 'Înregistrare cu succes',
        userMessage: 'Vă rugăm să introduceți numele de utilizator',
        verify: 'Vă rugăm să introduceți codul de verificare din 4 cifre',
        errorMsg: 'Formatul înălțimii trebuie să fie un număr întreg. Vă rugăm să introduceți din nou.',
        abnormalMsg: 'Eroare la înregistrare',
    },
    // 模型合成
    model: {
        loading: 'Tehnologie de percepție în profunzime',
        modelLoading: 'Se încarcă modelul...',
        tabPane: [
            {
                title: 'Tehnologie de percepție profundă',
                msg: 'Capturează cu precizie detaliile corpului prin scanare 3D, asigurând măsurarea circumferințelor la nivel milimetric și evidențiind clar schimbările corporale după antrenament.',
            },
            {
                title: 'Algoritmul de compoziție corporală BDA',
                msg: 'Visbody utilizează sistemul BDA de ultimă generație pentru a determina compoziția corporală, oferind o evaluare bazată pe volum pentru a estima mai precis riscurile de sănătate generate de obezitate.',
            },
            {
                title: 'Factori potențiali de eroare',
                msg: 'Îmbrăcămintea largă sau obiectele străine pot cauza erori. Pentru rezultate cât mai precise, purtați îmbrăcăminte mulată sau mai puține haine.',
            },
            {
                title: 'Acces raport',
                msg: 'Vă recomandăm să marcați pagina pentru acces ulterior. Puteți, de asemenea, să trimiteți acest raport pe e-mail pentru a-l salva.',
            },
        ],
        collect: ['Vă rugăm să marcați această pagină.', 'Pentru a accesa cu ușurință raportul mai târziu.'],
        know: 'Am înțeles',
        reminder: [
            'Notificare',
            'Modelul dumneavoastră 3D a fost generat. Încercați să glisați pentru a-l roti.',
            'Raportul dumneavoastră este gata. Apăsați pe butonul "Vizualizare raport" pentru a-l vedea.',
            'Evaluarea posturii a eșuat. Vă rugăm să vizualizați raportul de compoziție corporală.',
            'Analiza compoziției corporale a eșuat. Vă rugăm să încercați din nou la dispozitiv.',
            'Măsurătoarea a eșuat. Vă rugăm să reîncercați la dispozitiv.~',
            'Măsurarea compoziției corporale a eșuat. Vă rugăm să reîncercați la dispozitiv.~',
            'Evaluarea posturii a eșuat. Vă rugăm să reîncercați la dispozitiv.~',
        ],
        btn: {
            viewReport: 'Vizualizare raport',
            bodyReport: 'Vizualizare raport compoziție corporală',
            postureReport: 'Vizualizare raport postură',
            lastReport: 'Vizualizare raport anterior',
            loading: 'Se încarcă...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Descărcare raport',
            send: 'Trimitere raport',
            report: 'Raport',
        },
        reportSuccess: 'Raport generat cu succes',
        tabPane: {
            labelList: ['Ora măsurării', 'Parametru de măsurare', 'Compoziție corporală', 'Evaluare postură', 'Funcția umărului'],
        },
        sendEmail: 'Trimitere la adresa de e-mail:',
        requiredMsg: 'Adresă de e-mail',
        patternMsg: 'Vă rugăm să introduceți o adresă de e-mail validă',
        send: 'Trimite',
        download: 'Descărcare raport',
        sendReport: 'Trimitere raport',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Genul a fost actualizat cu succes',
            height: 'Înălțimea a fost actualizată cu succes',
            age: 'Vârsta a fost actualizată cu succes',
        },
        logOut: 'Deconectare',
        personal: 'Profil',
        cut: 'Schimbă unități/limbă',
        changeSort: 'Comutare raport produs',
        setPassword: 'Setare/Modificare parolă',
        accountSecurity: 'Cont și securitate',
        describe: '* După schimbarea modelului de produs, vor fi afișate toate rapoartele aferente.',
        describeBtn: 'După schimbarea modelului de produs, veți fi redirecționat(ă) la cel mai recent raport.',
        descReport: 'Raportul de produs a fost comutat cu succes',
        unit: ['Metric (kg, cm)', 'Imperial (ft, in, lb)'],
        read: {
            reading: 'Vizualizat',
            privacy: 'Confidențialitate',
        },
        setting: 'Setări',
        form: {
            labelList: ['Număr de telefon', 'Unități', 'Limbă', 'Poreclă', 'Gen', 'Înălțime', 'Vârstă'],
        },
        placeholder: ['Editare poreclă', 'Editare sex', 'Editare înălțime', 'Editare vârstă'],
        btn: {
            cancelBtn: 'Anulare',
            accomplishBtn: 'Terminat',
            confirmBtn: 'Confirmă',
        },
        dialog: [
            'Genul este un factor important în analiza compoziției corporale. Modificarea acestuia poate afecta comparația cu datele anterioare. Confirmați schimbarea?',
            'Înălțimea este un factor important în analiza compoziției corporale. Modificarea acesteia poate afecta comparația cu datele anterioare. Confirmați modificarea?',
            'Vârsta este un factor important în analiza compoziției corporale. Modificarea acesteia poate afecta comparația cu datele anterioare. Confirmați modificarea?',
        ],
        rules: {
            metricheight: ['Vă rugăm să introduceți o înălțime în intervalul (2ft3in–6ft7in)'],
            heightMsg: ['Vă rugăm să introduceți o înălțime în intervalul (70–200cm)'],
            ageMsg: ['Vă rugăm să introduceți o vârstă în intervalul (10–99 ani)', 'Intrare invalidă: vârsta trebuie să fie un număr întreg. Vă rugăm să introduceți o vârstă validă.'],
        },
        heightMsg: 'Vă rugăm selectați din nou înălțimea',
        ageMsg: 'Vă rugăm selectați din nou vârsta',
        ModelBinding: 'Se pare că altcineva a scanat codul înaintea dumneavoastră. Vă rugăm să măsurați din nou.',
        ReportEmpty: {
            title: 'Încă nu aveți rapoarte disponibile',
            desc: 'Găsiți scannerul corporal 3D Visbody și efectuați o măsurătoare!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Se pare că altcineva a scanat codul înaintea dumneavoastră. Vă rugăm să măsurați din nou.',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Încă nu aveți rapoarte disponibile',
        desc: 'Găsiți scannerul Visbody 3D și efectuați o măsurătoare!',
        descS30: 'Găsiți scannerul Visbody-S30 3D  și efectuați o măsurătoare!',
        descM30: 'Găsiți scannerul Visbody-M30 3D  și efectuați o măsurătoare!',
    },
    // 用户信息
    userInfo: {
        height: 'Înălțime:',
        age: 'Vârstă:',
        unit: 'Ani',
        weight: 'Greutate',
    },
    // 体成分
    mass: {
        title: 'Prezentare generală compoziție corporală',
        titles: 'Compoziție corporală',
        springFrame: '',
        massFrame: 'Nu există date de măsurare pentru astăzi',
        contrast: 'Selectare Raport Comparație',
        contrastReport: 'Alegeți un raport de comparație',
        noRecord: 'Fără înregistrări',
        score: 'Puncte',
        status: 'Starea actuală a compoziției corporale',
        WT: 'Greutate',
        PBF: 'Procent Grăsime Corporală',
        endSymbol: '.',
        // 测量相关
        measure: {
            value: 'Valori',
            standardRange: 'Interval standard',
            comparedWithLastLime: 'Evoluție vs. Anterior',
            comparedNet: 'Evoluție vs. Anterior',
            current: 'Scorul măsurătorii curente',
            WT: 'Greutate',
            FFM: 'Masă Slabă',
            BFM: 'Masă Grăsime',
            LM: 'Masă musculară',
            TBW: 'Apă Totală',
            SM: 'Mușchi scheletic',
            PROTEIN: 'Proteine',
            TM: 'Minerale',
            BMR: 'Metabolism Bazal',
            WHR: 'Raport talie-șold',
            BMI: 'BMI',
            PBF: 'Procent Grăsime Corporală',
            VFG: 'Grăsime Viscerală',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        // 定义解读
        explain: [
            {
                title: 'Greutate',
                msg: 'Greutatea este suma apei corporale, proteinelor, sărurilor anorganice și grăsimii corporale.',
            },
            {
                title: 'Masă Slabă',
                msg: 'Masa musculară este ansamblul țesuturilor fără grăsime, incluzând mușchiul scheletic, neted și cardiac.',
            },
            {
                title: 'Masă Grăsime',
                msg: 'Grăsimea corporală este suma grăsimii subcutanate, viscerale și intermusculare.',
            },
            {
                title: 'Masă musculară',
                msg: 'Masa musculară este grupul de țesuturi slabe ale corpului uman, incluzând mușchiul scheletic, mușchiul neted și mușchiul cardiac.',
            },
            {
                title: 'Apă Totală',
                msg: 'Apa corporală reprezintă 50%-70% din greutatea corporală. Se găsește în principal în celule și fluide, mai ales în celulele musculare.',
            },
            {
                title: 'Mușchi scheletic',
                msg: 'Mușchiul scheletic, numit și mușchi striat, este atașat de oase. Aici se afișează cantitatea acestuia.',
            },
            {
                title: 'Proteine',
                msg: 'Proteina este o substanță solidă care conține azot, prezentă în toate celulele și o componentă cheie a masei musculare.',
            },
            {
                title: 'Minerale',
                msg: 'Sărurile anorganice reprezintă aproximativ 5% din greutatea corporală.',
            },
            {
                title: 'Metabolism Bazal',
                msg: 'BMR este energia totală pe care corpul o consumă într-o zi în stare de veghe și repaus, neafectată de mișcare, alimente, tensiune nervoasă sau variații de temperatură externă.',
            },
            {
                title: 'Raport talie-șold',
                msg: 'Raportul talie-șold (RTS) este un indicator important pentru evaluarea obezității centrale.',
            },
            {
                title: 'BMI',
                msg: 'IMC este utilizat pentru a evalua gradul de adipozitate și este un standard internațional comun.',
            },
            {
                title: 'Procent Grăsime Corporală',
                msg: 'Procentul de grăsime corporală se referă la proporția de grăsime din greutatea totală a corpului.',
            },
            {
                title: 'Grăsime Viscerală',
                msg: 'Nivelul de grăsime viscerală este un indicator important pentru evaluarea obezității ascunse.',
            },
            {
                title: 'LIC',
                msg: 'Lichidul intracelular: lichidul din celule, parte fundamentală a protoplasmei.',
            },
            {
                title: 'LEC',
                msg: 'Lichidul extracelular: se referă la lichidul din afara celulelor, incluzând plasma și lichidul interstițial.',
            },
            {
                title: 'Vârstă metabolică',
                msg: 'Vârsta metabolică se referă la performanța corpului și a funcțiilor metabolice legate de sănătate.',
            },
            {
                title: 'Raport ECW/TBW',
                msg: 'Raportul ECW/TBW reprezintă proporția apei extracelulare (ECW) din apa corporală totală (TBW). Este un indicator important pentru evaluarea echilibrului lichidelor din organism.',
            },
        ],
        // 节段
        segment: {
            fat: 'Grăsime segmentală',
            muscle: 'Mușchi segmentali',
            right: 'Drept',
            left: 'Stâng',
            standard: 'Normal',
            lowStandard: 'Substandard',
            superStandard: 'Peste standard',
            peel: '(Tară)',
        },
    },
    // 体态
    shape: {
        title: 'Analiza Posturii',
        titles: 'Evaluare postură',
        status: 'Starea actuală a posturii',
        suggest: 'Recomandare',
        possibility: ', există',
        models: {
            front: 'Vedere frontală',
            left: 'Vedere din profil stâng',
            right: 'Vedere din profil drept',
            top: 'Spate',
            low: 'Sub medie',
            high: 'Peste medie',
            normal: 'Normal',
        },
        item: {
            deviate: 'Valori',
            result: 'Descriere',
            normal: 'Normal',
            abnormal: 'Anormal',
			keAbnormal: 'Anomalie potențială',
            head: 'Postură cu capul aplecat înainte',
            headSlant: 'Înclinare Laterală Cap',
            roundShoulderLeft: 'Postură cu umerii rotunjiți (partea stângă)',
            roundShoulderRight: 'Postură cu umerii rotunjiți (partea dreaptă)',
            highLowShoudler: 'Umeri denivelați',
            pelvis: 'Deplasare pelviană anterioară/posterioară',
            leftKneeCheck: 'Evaluarea genunchiului stâng',
            rightKneeCheck: 'Evaluarea genunchiului drept',
            leg: 'Forma picioarelor',
            leftLeg: 'Picior stâng:',
            rightLeg: 'Picior drept:',
        },
        // 定义解读
        explain: [
            {
                title: 'Postură cu capul aplecat înainte',
                msg: 'Unghiul dintre linia de la punctul urechii la centrul gâtului pe partea stângă și linia mediană laterală',
            },
            {
                title: 'Înclinare Laterală Cap',
                msg: 'Unghiul dintre linia de la punctul median al capului la centrul gâtului și linia mediană frontală',
            },
            {
                title: 'Postură cu umerii rotunjiți (partea stângă)',
                msg: 'Unghiul dintre cel mai înalt punct de pe spatele stâng și tangenta umărului',
            },
            {
                title: 'Postură cu umerii rotunjiți (partea dreaptă)',
                msg: 'Unghiul dintre cel mai înalt punct de pe spatele drept și tangenta umărului',
            },
            {
                title: 'Umeri denivelați',
                msg: 'Distanța verticală dintre acromionul stâng și cel drept pe spate',
            },
            {
                title: 'Deplasare pelviană anterioară/posterioară',
                msg: 'Unghiul dintre punctele de la centrul gâtului, șold și gleznă în vederea laterală stângă',
            },
            {
                title: 'Evaluarea genunchiului stâng',
                msg: 'Unghiul dintre șold, genunchi și gleznă în vederea laterală stângă',
            },
            {
                title: 'Evaluarea genunchiului drept',
                msg: 'Unghiul dintre șold, genunchi și gleznă în vederea laterală dreaptă',
            },
            {
                title: 'Forma picioarelor',
                msg: 'Unghiul format de șold, genunchi și gleznă în vederea frontală pentru ambele picioare',
            },
            {
                title: 'Înclinare pelviană anterioară/posterioară',
                msg: 'Unghiul dintre verticală și planul format de spinele iliace antero-superioare stânga și dreapta și simfiza pubiană.'
            },
            {
                title: 'Discrepanță de lungime a picioarelor',
                msg: 'Diferența de înălțime de la sol între punctele cele mai joase ale pliurilor fesiere stâng și drept'
            }
        ],
        exception: [
            {
                title: 'Deplasat spre stânga',
                abnormal: '',
            },
            {
                title: 'Deplasat spre dreapta',
                abnormal: '',
            },
            {
                title: 'Stânga mai sus',
                abnormal: '',
            },
            {
                title: 'Dreapta mai sus',
                abnormal: '',
            },
            {
                title: 'Deplasare pelviană posterioară',
                abnormal: '',
            },
            {
                title: 'Deplasare pelviană anterioară',
                abnormal: '',
            },
            {
                title: 'Hiperextensie genunchi stâng',
                abnormal: '',
            },
            {
                title: 'Flexie genunchi stâng',
                abnormal: '',
            },
            {
                title: 'Hiperextensie genunchi drept',
                abnormal: '',
            },
            {
                title: 'Flexie genunchi drept',
                abnormal: '',
            },
            {
                title: 'Picioare în formă de K',
                abnormal: '',
            },
            {
                title: 'Picioare în formă de D',
                abnormal: '',
            },
            {
                title: 'Picioare în X (genu valgum)',
                abnormal: '',
            },
            {
                title: 'Picioare în O (genu varum)',
                abnormal: '',
            },
            {
                title: 'Înclinare anterioară a pelvisului',
                abnormal: ''
            },
            {
                title: 'Înclinare posterioară a pelvisului',
                abnormal: ''
            },
            {
                title: 'Picior stâng anormal mai lung (discrepanță de lungime)',
                abnormal: ''
            },
            {
                title: 'Picior drept anormal mai lung (discrepanță de lungime)',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Distanța verticală dintre ureche și axa de gravitație a corpului',
            },
            {
                msg: 'Unghiul dintre linia care unește urechile și linia orizontală',
            },
            {
                msg: 'Distanța verticală dintre acromionul stâng și linia de gravitație',
            },
            {
                msg: 'Distanța verticală dintre acromionul drept și linia de gravitație',
            },
            {
                msg: 'Diferența dintre liniile baza gâtului–acromion stânga și dreapta',
            },
            {
                msg: 'Distanța verticală dintre articulația șoldului și linia de gravitație a corpului',
            },
            {
                msg: 'Unghiul dintre gleznă, punctul la 1 cm sub genunchiul stâng și șold (plan sagital)',
            },
            {
                msg: 'Unghiul dintre gleznă, punctul la 1 cm sub genunchiul drept și șold (plan sagital)',
            },
            {
                msg: 'Unghiul dintre șoldurile, genunchii și gleznele stângi/drepte (plan coronal)',
            },
        ],
        item: {
            pelvis: 'Deplasare pelviană anterioară',
        },
    },
    // 围度信息
    girth: {
        title: 'Circumferință corporală',
        present: '(Curent)',
        noHistory: 'Nu există date disponibile.',
        tpl: [
            {
                title: 'Gâtului',
                key: 'neckGirth',
            },
            {
                title: 'Brațului stâng superior',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Brațului drept superior',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Pieptului',
                key: 'bustGirth',
            },
            {
                title: 'Talie înaltă',
                key: 'waistGirth',
            },
            {
                title: 'Talie medie',
                key: 'midWaistGirth',
            },
            {
                title: 'Șoldurilor',
                key: 'hipGirth',
            },
            {
                title: 'Coapsei stângi',
                key: 'leftThighGirth',
            },
            {
                title: 'Mediană a coapsei stângi',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Circumferința minimă a coapsei stângi',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Circumferința coapsei drepte',
                key: 'rightThighGirth',
            },
            {
                title: 'Circumferința mediană a coapsei drepte',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Circumferința minimă a coapsei drepte',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Circumferința gambei stângi',
                key: 'leftCalfGirth',
            },
            {
                title: 'Circumferința gambei drepte',
                key: 'rightCalfGirth',
            },
            {
                title: 'Talie joasă',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Funcția umărului',
        model: {
            val: 'Valori',
            scope: 'Locația activității maxime',
            diff: 'Evoluție vs. Anterior',
        },
        normal: 'Nu s-au detectat anomalii notabile.',
        normalAll: 'Nu s-au detectat anomalii semnificative ale funcției umărului',
        conclusion: 'Concluzie',
        analyse: 'Analiză: ',
        suggest: 'Recomandare:',
        cause: 'Pentru o evaluare detaliată, vă rugăm consultați un specialist.',
    },
    reportTips: {
        title: "Sigur doriți să eliminați acest raport? După eliminare, acesta nu mai poate fi recuperat.",
        confirm: "Eliminare",
        success: "Raportul a fost eliminat",
        partial: "Raportul a fost eliminat, dar sincronizarea unor date a eșuat. Vă rugăm să contactați administratorul.",
        failed: "Eliminarea a eșuat, încercați mai târziu",
        btnMsg: 'OK',
        alaryTips: 'Acest raport a fost șters de administrator. Veți fi redirecționat la următorul raport.',
    },
    saveQr: {
        title: 'Raport corporal Visbody 3D',
        btnMsg: 'Apăsați lung pe imagine pentru a o salva pe telefon',
        tips: 'Dacă nu puteți salva, vă rugăm să activați permisiunile din [Setări]',
    },
    share: {
        title: 'Vă rugăm să copiați linkul de mai jos pentru a-l distribui',
        btnMsg: 'Copiere',
    },
    bodyPrediction: {
        'body-title': 'Predicție formă corporală',
        'body-yu-ce-status': 'Prognoză pe baza stării dumneavoastră actuale.',
        'body-setting': 'Setări predicție formă corporală',
        'body-li-xiang': 'Valori ideale: ',
        'body-ti-zhong': 'Greutate',
        'body-ti-zhi-lv': 'Procent Grăsime Corporală',
        'body-ji-rou': 'Masă musculară',
        'yu-che-pre': 'Înainte',
        'yu-che-after': 'După',
        'zan-model-no': 'Nu există model disponibil.',
        'ti-xing-error': 'Predicția formei corporale a eșuat.',
        'ti-xing-worker-error': 'Posibil din cauza rețelei. Verificați conexiunea.',
        'ti-xing-adjust': 'Ajustare:',
        'ji-rou-title': 'Masă musculară',
        'ti-zi-fang': 'Masă Grăsime',
        'dang-pre-zhi': 'Valori curente: ',
        'nen-zhang': 'Grăsime Viscerală',
        'nen-zhang-title': 'Explicație privind aria grăsimii viscerale',
        'nen-zhang-title1':
            'Grăsimea viscerală: grăsimea din jurul organelor interne, favorizează obezitatea abdominală. Aria indică măsurătoarea secțiunii transversale.',
    },
    ...en,
    ...agrEn,
    wifi: {
        title: 'Setări Wi-Fi',
        tips: 'Introduceți parola pentru următoarea rețea WiFi',
        password: 'Parolă WiFi',
        'password-placeholder': 'Introduceți parola WiFi',
        'password-tips': 'Parola este sensibilă la majuscule și minuscule; asigurați-vă că o introduceți corect',
        button: 'Generare cod QR',
        'h5-title': 'Configurare informații WiFi',
        'wifi-name': 'Nume WiFi:',
        'wifi-password': 'Parolă WiFi:',
        'wifi-qr-tips1':
            '* Confirmați numele și parola WiFi, apoi aliniați codul QR cu camera situată sub ecranul dispozitivului pentru scanare.',
        'wifi-qr-tips2': 'Aliniați codul QR Wi-Fi cu camera de sub ecran pentru scanare.',
        'wifi-qr-button': 'Înapoi',
    },
    "waist": {
    "title": "Evaluarea taliei și abdomenului",
    "hou": "Spate",
    "qian": "Față"
  },
  "yao_wei_1": "Talie",
  "yao_bu_fen_shu": "Scor talie",
  "waist_fen": "Scor",
  "yao_wei": "Circumferința taliei",
  "yao_wei_jian_ti_ji": "Volum între circumferințele taliei",
  "yao_tun_bi": "Raport talie-șold",
  "lun_kuo_fen_xi": "Analiza conturului",
  "bei_bu": "Regiunea spatelui",
  "tunbu": "Regiunea fesieră",
  "bei_bu_ti_ji": "Volumul spatelui",
  "zheng_chang_fan_wei": "Interval normal:",
  "shang_ci": "Anterior",
  "ben_ci": "Curent",
  "gupen": {
    "zheng_chang": "Normal",
    "qian_qin_yan_chang": "Înclinare anterioară anormală",
    "qian_qin_yi": "Risc de înclinare anterioară",
    "hou_qin_yi": "Risc de înclinare posterioară",
    "hou_qin_yan_chang": "Înclinare posterioară anormală",
    "zuo_chang_yan_chang": "Piciorul stâng mai lung decât normal (discrepanță de lungime)",
    "zuo_chang_yi": "Risc ca piciorul stâng să fie mai lung",
    "you_chang_yi": "Risc ca piciorul drept să fie mai lung",
    "you_chang_yan_chang": "Piciorul drept mai lung decât normal (discrepanță de lungime)"
  },
  "gao_yao_xian": "Talie înaltă",
  "gao_yao_zhong_xian": "Linia mediană a taliei înalte",
  "gao_yao_xia_xian": "Linia inferioară a taliei înalte",
  "xiao_yao_shang_xian": "Linia superioară a taliei joase",
  "xiao_yao_zhong_xian": "Linia mediană a taliei joase",
  "xiao_yao_xian": "Talie joasă",
  "qv_jian1": "Secțiunea superioară a taliei înalte",
  "qv_jian2": "Secțiunea inferioară a taliei înalte",
  "qv_jian_zhong": "Secțiunea taliei medii",
  "qv_jian3": "Secțiunea superioară a taliei joase",
  "qv_jian4": "Secțiunea inferioară a taliei joase",
  "celiang.failed": "Măsurătoare eșuată. Vă rugăm să purtați îmbrăcăminte mulată și să rămâneți nemișcat(ă) în timpul măsurătorii.",
    "jie-gou-yi-chang-ping-gu": "Evaluare anomalii structurale",
  "teng-tong-feng-xian-ping-gu": "Evaluarea riscului de durere",
  "zheng-chang": "Normal",
  "qing-du-yi-chang": "Anomalie ușoară",
  "zhong-du2-yi-chang": "Anomalie moderată",
  "zhong-du-yi-chang": "Anomalie severă",
  "pen-gu-zhuan-xiang-feng-xian-ping-gu": "Evaluarea riscului pelvian specializat",
  "qian-qing": "Înclinare anterioară",
  "hou-qing": "Înclinare posterioară",
  "xuan-zhuan": "Rotație",
  "pen-gu-qian-qing-feng-xian-fen-shu": "Scorul de risc de înclinare anterioară pelviană",
  "pen-gu-hou-qing-feng-xian-fen-shu": "Scorul de risc de înclinare posterioară pelviană",
  "pen-gu-xuan-zhuan-feng-xian-fen-shu": "Scorul de risc de rotație pelviană",
  "fen": "Puncte",
  "gao-feng-xian": "Risc ridicat",
  "ji-rou-ping-gu-jie-guo": "Rezultatele evaluării mușchilor",
  "qian-qing-feng-xian-gao": "Risc ridicat de înclinare anterioară",
  "hou-qing-feng-xian-gao": "Risc ridicat de înclinare posterioară",
  "xuan-zhuan-feng-xian-gao": "Risc ridicat de rotație",
  "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Ilopsoas/erector spinal inferior tensionat, transvers abdominal slab.",
  "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo": "Ischiogambieri, fesieri și erectori spinali tensionați; ilopsoas slab.",
  "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng": "Slăbiciune unilaterală a gluteului mijlociu / dezechilibru al cvadratului lombar.",
  "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Evaluarea mușchilor pelvieni este normală, vă rugăm să continuați să mențineți bune obiceiuri de viață.",
  "yi-shang-xiang-mu-jun-zheng-chang": "Toate elementele de mai sus sunt normale.",
  "ji-zhu-jie-gou-yi-chang-ping-gu": "Evaluarea anomaliei structurale a coloanei vertebrale",
  "zheng-ti-ping-fen": "Scor general",
  "jing-zhui": "Coloana cervicală",
  "xiong-zhui": "Coloana toracică",
  "yao-zhui": "Coloana lombară",
  "jing-zhui-jie-gou-yi-chang-ping-fen": "Scorul anomaliei structurale a coloanei cervicale",
  "xiong-zhui-jie-gou-yi-chang-ping-fen": "Scorul anomaliei structurale a coloanei toracice",
  "yao-zhui-jie-gou-yi-chang-ping-fen": "Scorul anomaliei structurale a coloanei lombare",
  "jing-zhui-ji-rou-ping-gu": "Evaluarea mușchilor coloanei cervicale",
  "xiong-zhui-ji-rou-ping-gu": "Evaluarea mușchilor coloanei toracice",
  "yao-zhui-ji-rou-ping-gu": "Evaluarea mușchilor coloanei lombare",
  "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "Aliniamentul general al coloanei este în mare parte normal.",
  "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang": "Postura capului și aliniamentul cervical sunt în limite normale.",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Cap aplecat/înclinat cu ușoară deviație cervicală. Atenție la postura așezat.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Cap aplecat/înclinat cu deviație cervicală. Se recomandă control postural și antrenament.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Cap puternic aplecat/înclinat și deviație cervicală. Evaluare profesională recomandată.",
  "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang": "Aliniamentul toracic este în general normal, fără anomalii structurale semnificative.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Ușoară deviație toracică. Se recomandă îmbunătățirea controlului postural.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Deviația toracică afectează stabilitatea. Se recomandă antrenament specific.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Deviație toracică evidentă și asimetrie. Corecție profesională recomandată.",
  "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "Aliniamentul lombar este normal, postură echilibrată, fără anomalii structurale semnificative.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Ușoară deviație lombară, postură echilibrată. Stabilizare core recomandată.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Deviația lombară afectează stabilitatea. Antrenament corectiv recomandat.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Deviație lombară evidentă. Plan de îmbunătățire profesional recomandat.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hipertonie: ridicător al scapulei, SCM, trapez superior. Slăbiciune: flexori profunzi ai gâtului. Stabilizare și relaxare recomandate.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonie: SCM stâng și scalen posterior. Slăbiciune: SCM drept. Echilibru bilateral și relaxare recomandate.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonie: SCM drept. Slăbiciune: SCM stâng și scalen posterior. Stabilizare simetrică și relaxare recomandate.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonie: trapez superior stâng. Slăbiciune: trapez mijlociu/inferior. Antrenament (mijloc/jos) și relaxare recomandate.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hipertonie: rotatori interni și adductori ai șoldului. Slăbiciune: gluteu mijlociu. Antrenament gluteu și stretching recomandate.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hipertonie: gluteu mijlociu și piriform. Slăbiciune: adductori, rotatori interni, LCL. Stabilizarea picioarelor și relaxarea fesierilor recomandate.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hipertonie: gluteu mijlociu și piriform. Slăbiciune unilaterală: adductori, rotatori interni, LCL. Antrenament bilateral recomandat.",
  "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Se recomandă menținerea unui antrenament echilibrat și evitarea suprautilizării unilaterale.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonie: ischiogambieri stângi și popliteu. Slăbiciune: cvadriceps și solear. Antrenament cvadriceps/solear și stretching recomandate.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonie: cvadriceps stâng. Slăbiciune: gluteu mare și ischiogambieri. Antrenament fesieri/lanț posterior și stretching recomandate.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonie: ischiogambieri drepți și popliteu. Slăbiciune: cvadriceps și solear. Antrenament cvadriceps/solear și stretching recomandate.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonie: cvadriceps drept. Slăbiciune: gluteu mare și ischiogambieri. Antrenament fesieri/lanț posterior și stretching recomandate.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Ușoară deviație spinală. Atenție la postură și antrenați core-ul.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Deviație spinală moderată. Antrenament ghidat profesional recomandat.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu":
      "Anomalie structurală severă a coloanei vertebrale. Se recomandă consult medical multidisciplinar.",
  "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan":
      "Evaluarea musculară este normală. Continuați să mențineți un stil de viață sănătos.",
  "teng-tong-qian-zai-feng-xian-ping-gu": "Evaluarea riscului potențial de durere",
  "jing-bu": "Gât",
  "bei-bu": "Spate",
  "yao-bu": "Zona lombară",
  "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Scor potențial de durere cervicală",
  "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Scor potențial de durere dorsală",
  "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Scor potențial de durere lombară",
  "di-feng-xian": "Risc scăzut",
  "zhong-feng-xian": "Risc mediu",
  "ji-zhu-jie-gou-ke-shi-hua": "Vizualizarea structurii coloanei vertebrale",
  "tuo-dong-xuan-zhuan-shi-tu": "Trageți pentru a roti",
  "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun":
      "Acest model este doar informativ. Evaluarea clinică se bazează pe examinarea profesională.",
  "bei-mian": "Spate",
  "zheng-shi-tu": "Vedere frontală",
  "you-shi-tu": "Vedere din dreapta",
  "hou-shi-tu": "Vedere posterioară",
  "zuo-shi-tu": "Vedere din stânga",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonie: trapez superior drept. Slăbiciune: trapez mijlociu/inferior. Antrenament (mijloc/jos) și relaxare recomandate.",
  "tun-xing": "Formă fesieră",
  "dui-bi": "Comparație",
  "fang-xing-tun": "Formă pătrată",
  "li-xing-tun": "Formă de pară",
  "dao-san-jiao-xing-tun": "Formă în V inversat",
  "yuan-xing-tun": "Formă rotunjită",
  "jiao-li-xiang": "Formă bună",
  "mi-tao-tun": "Formă tip „piersică”",
  "ben-ci": "Curent",
  "li-shi": "Istoric",
  "ben-ci-li-shi": "Curent, Istoric",
  "tun-wei": "Circumferință fesieră",
  "tun-xing-shuo-ming": "Despre formele fesierilor",
  "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai":
      "Forma fesierilor se referă la curbura și conturul zonei dintre zona lombară inferioară și coapse. Această evaluare poate ajuta la gestionarea esteticii corporale și a sănătății.",
  "wo-zhi-dao-le": "Am înțeles",
  "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du":
      "Formă pătrată: lățime similară sus și jos, laturi mai drepte, curbe mai puțin definite.",
  "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing":
      "Formă rotunjită: grăsime repartizată uniform, aspect plin și echilibrat; considerată formă fesieră ideală.",
  "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man":
      "Formă de pară: mai îngustă sus și mai lată jos, mai multă masă musculară și grăsime în partea inferioară.",
  "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing":
      "Formă în V inversat: mai lată sus și mai îngustă spre bază, asemănătoare unui triunghi inversat.",
  "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing":
      "Formă tip „piersică”: plinătate în partea inferioară a feselor și talie mai subțire; considerată formă ideală.",
  "zan-wu-mo-xing": "Nu există model disponibil.",
  "ce-liang": "Măsurătoare",
  "ben-ci-ce-liang": "Măsurătoare curentă",
  "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang":
      "Generarea modelului pentru măsurătoarea curentă a eșuat. Scanați din nou la dispozitiv.",
  "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi":
      "Nu există model pentru această dată. Selectați o altă dată pentru comparație.",
  "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "Prima măsurătoare, fără date istorice disponibile.",
  "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia":
      "Încărcarea modelului a eșuat. Reîmprospătați pagina și încercați din nou.",
  "jing-zhui-7": "C7 (a 7-a vertebră cervicală)",
  "di-gu-zhong-dian": "Punct median al sacrului",
  "di-gu-hou-shang-jiao": "Unghi sacral postero-superior",
  "ren-ti-zhong-xin": "Centru de greutate",
  "spine-tips1":
      "Acest raport are doar caracter informativ și nu constituie bază pentru diagnostic medical. Se recomandă o evaluare comprehensivă împreună cu un medic.",
  "spine-tips2": "Sistemul de evaluare a sănătății coloanei vertebrale Visbody 2025",
  'tun-xing-ping-gu': 'Evaluarea formei fesierilor',
  "yi-xia-shi-nin-de-tun-xing-lei-xing": "Iată tipul dumneavoastră de formă fesieră",
  "qi-ta-tun-xing": "Alte forme fesieri",
  "ji-zhu-ping-gu": "Evaluarea coloanei vertebrale",
  "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu": "Evaluarea riscului pentru sănătatea coloanei la adolescenți",
  "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "Index de dezvoltare a coloanei la adolescenți",
  "xue-xi-zi-shi-fu-he-zhi-shu": "Index al sarcinii posturale legate de studiu",
  "gu-ge-ping-heng-zhi-shu": "Index de echilibru osos",
  "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "Index de avertizare pentru dureri de creștere",
  "ji-zhu-ce-wan-feng-xian-ping-fen": "Scor de risc de scolioză",
  "qia-yao-ji-shu-ji-ji": "Ilopsoas/Erector spinal",
  "xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Tensiune în regiunea inferioară, transvers abdominal slab",
  "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti":
      "Dezvoltare normală a coloanei vertebrale, fără probleme structurale semnificative.",
  "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan":
      "Riscuri minore de dezvoltare. Se recomandă îmbunătățirea obiceiurilor posturale.",
  "zhong-du-fa-yu-feng-xian": "Risc moderat de dezvoltare",
  "yan-zhong-ying-xiang-ji-zhu-fa-yu": "Afectează grav dezvoltarea coloanei vertebrale",
  "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi": "Postură bună la studiu, menținută pe perioade lungi",
  "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi":
      "Postura necesită îmbunătățiri; se recomandă pauză la fiecare 45 de minute",
  "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen":
      "Probleme posturale evidente; este necesar stretching regulat",
  "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu":
      "Postură foarte deficitară la studiu, poate afecta randamentul școlar și dezvoltarea",
  "gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding": "Dezvoltare osoasă simetrică, postură stabilă",
  "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce": "Asimetrie ușoară; se recomandă monitorizare",
  "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi": "Dezvoltare neuniformă; sunt necesare măsuri corective",
  "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang":
      "Asimetrie osoasă severă, afectează creșterea",
  "zi-shi-liang-hao-teng-tong-feng-xian-di": "Postură bună, risc scăzut de durere",
  "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li":
      "Risc ușor de durere; se recomandă gestionarea posturii",
  "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao":
      "Risc moderat de durere; este necesară îndrumare profesională",
  "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan":
      "Risc ridicat de durere; este posibil să existe deja disconfort",
  "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan":"Risc scăzut, vă rugăm să mențineți bune obiceiuri posturale",
  "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu":"Risc mediu, posibil necesita observație sau intervenție ulterioară",
  "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu":"Risc ridicat, necesită consultare medicală urgentă pentru evaluare medicală profesională",
  "you-liang":"Excelent",
  "zhu-yi":"Atenție",
  "gan-yu":"Intervenție",
  "jing-shi":"Avertisment",
  "di-fu-he":"Sarcină scăzută",
  "zhong-fu-he":"Sarcină medie",
  "gao-fu-he":"Sarcină ridicată",
  "guo-zai":"Sarcină excesivă",
  "ping-heng-xing":"Echilibrat",
  "qing-du-bu-ping-heng":"Dezechilibru ușor",
  "zhong-du-bu-ping-heng":"Dezechilibru moderat",
  "yan-zhong-bu-ping-heng":"Dezechilibru sever",
  "an-quan":"Siguranță",
  "wei-xian":"Periculos",
  "neckReport": {
  "title": "Funcția gâtului",
  "conclusion": "Evaluarea funcțională a gâtului",
  "loading": "Raportul este în curs de generare. Vă rugăm să așteptați.",
  "failed": "Generarea raportului a eșuat",
  "analysis": "Analiză",
  "suggestion": "sugestie",
  "suggestionText": "Consultați un specialist pentru a face un screening suplimentar și tratament al cauzei specifice."
}
}
